import { registerPlugin } from '@capacitor/core';

interface PrinterDesktop {
  print: (data: {imageUrl: string}) => any;
}

const PrinterDesktop = registerPlugin<PrinterDesktop>('PrinterDesktop');

export default PrinterDesktop;
